import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import { UserDataModel } from '../interface/user-data-model';

@Injectable({
    providedIn: 'root'
})
export class UserDataService {
    userData: any;
    userValidation: BehaviorSubject<boolean>;
    constructor() {
        this.userData = new BehaviorSubject<any>(null);
        this.userValidation = new BehaviorSubject<boolean>(false);
    }

    setUserData(userData: UserDataModel) {
        this.userData.next(userData);
    }

    getUserData() {
        return this.userData.asObservable();
    }

    getUserValidation() {
      return this.userValidation.asObservable();
    }

    setUserValidation(value) {
      this.userValidation.next(value);
    }


}
